import type { HttpClient } from '~/shared/api'
import type { LoggerFactory } from '~/shared/interfaces'
import { ResearchShowcaseMainService } from './ResearchShowcaseMainService'
import { ResearchShowcaseDetailService } from './ResearchShowcaseDetailService'
import { ResearchShowcaseFormsService } from './ResearchShowcaseFormsService'

export { default as ResearchShowcaseApplicationForm } from './ResearchShowcaseApplicationForm'
export { default as ResearchShowcaseRequestForm } from './ResearchShowcaseRequestForm'

export class ResearchShowcaseService {
  readonly main: ResearchShowcaseMainService
  readonly detail: ResearchShowcaseDetailService
  readonly forms: ResearchShowcaseFormsService

  constructor(http: HttpClient, createLogger: LoggerFactory) {
    this.main = new ResearchShowcaseMainService(http)
    this.detail = new ResearchShowcaseDetailService(http, createLogger('ResearchShowcaseDetailService'))
    this.forms = new ResearchShowcaseFormsService(http)
  }
}
